import { render, staticRenderFns } from "./TimetableModal.vue?vue&type=template&id=22d98cd7&"
import script from "./TimetableModal.vue?vue&type=script&lang=js&"
export * from "./TimetableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TimetableModal.vue"
export default component.exports